module.exports = __webpack_public_path__ + "img/icon-06.33300010.png";